import { Card, Typography } from "antd";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";

const { Title } = Typography;

interface ProvinceData {
  province_id: number;
  province_name: string;
  count: number;
}

interface Props {
  data: ProvinceData[];
  loading?: boolean;
}

export const TopProvincesChart = ({ data, loading }: Props) => {
  return (
    <Card loading={loading}>
      <Title level={5}>Top 10 Provincias con Más Puntos de Control</Title>
      <ResponsiveContainer width="100%" height={400}>
        <BarChart data={data} layout="vertical">
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis type="number" />
          <YAxis dataKey="province_name" type="category" width={150} />
          <Tooltip />
          <Bar dataKey="count" fill="#1890ff" name="Puntos de Control" />
        </BarChart>
      </ResponsiveContainer>
    </Card>
  );
};
